import { render } from "./LearningVideoForm.vue?vue&type=template&id=42530ac2"
import script from "./LearningVideoForm.vue?vue&type=script&lang=js"
export * from "./LearningVideoForm.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__